import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=249ad86c&scoped=true&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"
import style0 from "./Flight.vue?vue&type=style&index=0&id=249ad86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ad86c",
  null
  
)

export default component.exports